import React, { FC, useEffect, useState } from "react";
import NotificationPopUp from "../../../extras/NotificationPopUp";
import { API_URL } from "../../../../actions/settings";
import { IonButton, IonCol, IonIcon, IonRow } from "@ionic/react";
import { pencilSharp, saveSharp } from "ionicons/icons";

interface IProps {
    id: string | null | undefined;
    hidden:boolean;
};

async function getBuilding(token: any, id: any) {
  return fetch(`${API_URL}/buildings/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((response) =>{
    if(response.ok)
      return response.json()
    else{
      NotificationPopUp('Error',"Could Not load Notes for this building.","Error Loading Data")
    }
  })
  .catch(error => NotificationPopUp('error',error.message));
}

async function saveNotes(id: any, token: string, data:any) {
    return fetch(`${API_URL}/buildings/${id}/update_attribute`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
      
    })
      .then((res) => {
        if (res.ok) {
          NotificationPopUp("Success", "Notes Saved", "Success");          
        } else {
          res.json().then((err) => {
            NotificationPopUp("Error", err, "Error Saving Notes");
          });
        }
      })
      .catch((error) => {
        NotificationPopUp("Error", error.message, "Error Saving Notes");
      });
  }

const AdjustmentNotes:FC<IProps> = ({id,hidden}) => {

    const [notes, setNotes] = useState('No Notes')
    const [editNotes, setEditNotes] = useState(false)

    const handleSaveNotes = async () =>{
      const token = `Token ${(localStorage.getItem("token") || "").slice(
          1,
          -1
        )}`;
      
      const data = {
        'weather_adjustment_notes':notes
      }
      
      await saveNotes(id,token,data)
      setEditNotes(false)
    }


    useEffect(() => {

      const handleBuilding = async ()=>{
        const token = `Token ${(localStorage.getItem("token") || "").slice(
          1,
          -1
        )}`;

        const res = await getBuilding(token,id)
        if(res && res.status === 'success'){
          if(res.data.weather_adjustment_notes){
            setNotes(res.data.weather_adjustment_notes)
          }
          else{
            setNotes('')
          }
        }

        
      }


      handleBuilding();
        // eslint-disable-next-line
    }, [id]);

    return <div hidden={hidden} style={{
        width: "100%",
        // justifyContent: "center",
        margin: "1em",
      }}
      className="grey-border-2pt">
        <div style={{width:'100%'}}>
             <div style={{ display: 'flex'}}
             ><h4>Adjustment Notes</h4>
            {editNotes ?
            <IonButton fill="clear" size="small"  onClick={()=>handleSaveNotes()} title="Save Notes">
              <IonIcon src={saveSharp}/>
            </IonButton> :
            <IonButton fill="clear" size="small" onClick={()=>setEditNotes(true)} title="Edit Notes">
              <IonIcon src={pencilSharp}/>
            </IonButton>
            }
            </div>
          
            <IonRow>
                <IonCol>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                        <textarea
                            style={{
                                width: '100%',
                                minHeight: '100px',
                                padding: '0.6rem',
                                margin:'1rem',
                                border:  editNotes ? '3px solid #007bff' : '1pt solid grey',
                                borderRadius: '4px',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                fontSize: 'inherit',
                                color: 'black'
                            }}
                            value={notes}
                            readOnly={!editNotes}
                            placeholder="No notes available."
                            onChange={(e) => setNotes(e.target.value)}
                        />
                        
                    </div>
                </IonCol>
            </IonRow>

        </div>

    </div>
};

export default AdjustmentNotes;